export default [
  {
    name: 'home',
    path: '/',
    component: () => import('@/views/tv/Home'),
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/views/tv/404'),
  },
  {
    name: 'video',
    path: '/video/:pid',
    component: () => import('@/views/tv/Video'),
  },
  {
    name: 'splash',
    path: '/splash/:pid',
    component: () => import('@/views/tv/Splash'),
  },
  {
    name: 'playlist',
    path: '/playlist/:pid',
    component: () => import('@/views/tv/Playlist'),
  },
  {
    path: '/account',
    component: () => import('@/views/tv/account'),
  },
  // {
  //   path: '/categories',
  //   component: () => import('@/views/tv/categories'),
  // },
  // {
  //   path: '/channels',
  //   component: () => import('@/views/tv/channels'),
  // },
  // {
  //   path: '/forgot-password',
  //   component: () => import('@/views/tv/forgot-password'),
  // },
  // {
  //   path: '/history-page',
  //   component: () => import('@/views/tv/history-page'),
  // },
  // {
  //   path: '/index',
  //   component: () => import('@/views/tv/index'),
  // },
  // {
  //   path: '/intro',
  //   component: () => import('@/views/tv/intro'),
  // },
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/tv/login'),
  },
  {
    name: 'register',
    path: '/register',
    component: () => import('@/views/tv/register'),
  },
  // {
  //   path: '/settings',
  //   component: () => import('@/views/tv/settings'),
  // },
  // {
  //   path: '/single-channel',
  //   component: () => import('@/views/tv/single-channel'),
  // },
  // {
  //   path: '/subscriptions',
  //   component: () => import('@/views/tv/subscriptions'),
  // },
  // {
  //   path: '/upload-video',
  //   component: () => import('@/views/tv/upload-video'),
  // },
  // {
  //   path: '/upload',
  //   component: () => import('@/views/tv/upload'),
  // },
  // {
  //   path: '/video-page',
  //   component: () => import('@/views/tv/video-page'),
  // },
  // {
  //   path: '/contact',
  //   component: () => import('@/views/tv/contact'),
  // },
  // {
  //   path: '/blog',
  //   component: () => import('@/views/tv/blog'),
  // },
  // {
  //   path: '/blog-detail',
  //   component: () => import('@/views/tv/blog-detail'),
  // },
  // default route
  // {
  //   path: '/',
  //   redirect: '/',
  // },

];
